import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Input,
  Form,
  Modal,
} from "antd";
import {
  BsThreeDotsVertical,
} from "react-icons/bs";
import "../../App.css";

import type { TableProps } from "antd";
import { fetchReportData } from "../../Helpers/APIEndpoints/Endpoints";
import { API } from "../../Axios/Axios";





interface EditableCellProps {
  editing: boolean;
  dataIndex: string;
  title: string;
  inputType: string;
  record: any;
  children: React.ReactNode;
  save: (key: any, value: any, dataIndex: string, form: any) => void;
  restProps?: any;
}

const EditableCell: React.FC<EditableCellProps> = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  children,
  save,
  ...restProps
}) => {
  const [form1] = Form.useForm();

  const inputNode =
    inputType === "number" ? <InputNumber /> : <Input />;

  const inputRef = React.useRef<any>(null);

  return (
    <td {...restProps}>
      <Form form={form1} component={false}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: `Please Input ${title}!`,
              },
              {
                validator: async (_: any, value: any) => {
                  if (dataIndex === "age" && isNaN(value)) {
                    return Promise.reject(
                      new Error("Age should be a number")
                    );
                  }
                  if (dataIndex === "age" && value <= 15) {
                    return Promise.reject(
                      new Error("Age should be > 15")
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            {React.cloneElement(inputNode, {
              ref: inputRef,
              defaultValue: record[dataIndex],
              onBlur: (e: any) =>
                save(record.key, e.target.value, dataIndex, form1),

              onMouseEnter: () => inputRef.current?.focus(),
            })}
          </Form.Item>
        ) : (
          children
        )}
      </Form>
    </td>
  );
};


const FormInlineTable = ({
  fields = [],
  name,
  onChange,
  keyIdentity = null,
  form,
  field = {},
  ...rest
}: any) => {
  const [updatedColumns, setUpdatedColumns] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState([]);

  const [isVisibleColumnsModalVisible, setIsVisibleColumnsModalVisible] =
    useState(false);
  const [visibleColumnsModalSearchText, setVisibleColumnsModalSearchText] =
    useState<string>(""); // State for search input



  useEffect(() => {
    if (fields && fields.length > 0) {
      setTableColumnFunction();
      callTableDataApi();
    }
  }, [fields]);

  const setTableColumnFunction = () => {
    let tempCol = [];
    setVisibleColumns(
      [...fields].map((data) => {
        return data.name;
      })
    );

    for (const field of fields) {
      const colObj = {
        key: field?.name,
        dataIndex: field?.name,
        title: field?.label,
        isFieldEditable: field?.isFieldEditable,
        Id: field?.Id,
        fieldInterfaceId: field?.fieldInterfaceId,
        parentId: field?.parentId,
        IsActive: field?.IsActive,
        rowSpan: field?.rowSpan,
        rowSpanStart: field?.rowSpanStart,
        rowSpanEnd: field?.rowSpanEnd,
      };

      tempCol.push(colObj);
    }

    setUpdatedColumns(tempCol);
  };

  const getRowSpanProps = (col: any, index: number, total: number) => {
    if (!col.rowSpan) return {};

    const start = col.rowSpanStart && col.rowSpanStart > 0
      ? col.rowSpanStart - 1
      : 0;

    const end = col.rowSpanEnd && total >= col.rowSpanEnd
      ? col.rowSpanEnd
      : total;

    if (index === start) return { rowSpan: end - start };
    if (index > start && index <= end) return { rowSpan: 0 };

    return {};
  };

  const getColSpanProps = (col: any, index: number, total: number) => {
    if (!col.colSpan) return {};

    const start = col.colSpanStart && col.colSpanStart > 0
      ? col.colSpanStart - 1
      : 0;

    const end = col.colSpanEnd && total >= col.colSpanEnd
      ? col.colSpanEnd
      : total;

    if (index === start) return { colSpan: end - start };
    if (index > start && index <= end) return { colSpan: 0 };

    return {};
  };


  const callTableDataApi = async () => {
    try {
      const request = {// NOSONAR : ignore
        UserId: 6,
        RoleId: 1,
        PageNumber: PageNumber,
        PageSize: PageSize,
        interfaceId: field.fieldInterfaceId,
      };
      const response = await API.post(fetchReportData);

      if (
        response &&
        response.status == 0 &&
        response.data &&
        response.data.length > 0
      ) {
        console.log("success from callTableDataApi: ", response.status);
      }
    } catch (err) {
      console.log("Errr from callTableDataApi: ", err);
    }
  };

  const mergedColumns = updatedColumns
    .map((col: any) => {
      return {
        ...col,
        onCell: (record: any, index: number) => {
          const baseObj = {
            record,
            inputType: col.type,
            dataIndex: col.name,
            title: col.title,
            editing: col.isFieldEditable,
          };

          const rowSpanProps = getRowSpanProps(col, index, data.length);
          const colSpanProps = getColSpanProps(col, index, data.length);

          return {
            ...baseObj,
            ...rowSpanProps,
            ...colSpanProps,
          };
        },

      };
    })
    .filter((column: any) => visibleColumns.includes(column.dataIndex));

  const newupdatedColumns = [...mergedColumns];


  const handleTableChange = (pagination: any, extra: any) => {

    const newColumns = updatedColumns.map((column: any) => {
      column.filterIcon = getFilterIcon;
      return column;
    });

    const getFilterIcon = (filtered: boolean) => (
      <div style={{ display: "flex", justifyContent: "space-between", gap: 3 }}>
        <BsThreeDotsVertical
          style={{
            color: filtered ? "blue" : "black",
            fontSize: "18px",
          }}
        />
      </div>
    );


    setUpdatedColumns(newColumns);
    onChange?.(pagination, extra);
  };

  // Handle opening the column management modal
  const handleManageColumns = () => {// NOSONAR : ignore
    setIsVisibleColumnsModalVisible(true);
  };

  // Handle closing the modal
  const handleCancel = () => {
    setVisibleColumnsModalSearchText("");
    setIsVisibleColumnsModalVisible(false);
  };

  // Handle column visibility toggle
  const handleColumnToggle = (columnKey: string, checked: boolean) => {// NOSONAR : ignore
    setVisibleColumns((prevVisibleColumns) =>
      checked
        ? [...prevVisibleColumns, columnKey]
        : prevVisibleColumns.filter((key) => key !== columnKey)
    );
  };

  // Handle search input change
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setVisibleColumnsModalSearchText(e.target.value);
  };

  // Render the column visibility management modal
  const renderColumnVisibilityModal = () => (
    <Modal
      title="Manage Columns"
      open={isVisibleColumnsModalVisible}
      onCancel={handleCancel}
      footer={null}
      width={300} // Adjust the width of the modal
      style={{
        maxHeight: "400px", // Medium height for the modal
        // Enable scrolling for content inside the modal
      }}
    >
      <div>
        {/* Search input field */}
        <Input
          placeholder="Search Columns"
          value={visibleColumnsModalSearchText}
          onChange={handleSearchChange}
          style={{ marginBottom: 15 }}
        />

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={handleCancel}>Close</Button>
        </div>
      </div>
    </Modal>
  );

  // For the row selection.
  const rowSelection: TableProps<DataType>["rowSelection"] = {// NOSONAR : ignore
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
    },
    getCheckboxProps: (record: DataType) => ({
      disabled: record.name === "Disabled User", // Column configuration not to be checked
      name: record.name,
    }),
  };

  return (
    <Form form={form} component={false} style={{ width: "100%" }}>
      {renderColumnVisibilityModal()}
      <Form.Item name={name} hidden>
        <Input />
      </Form.Item>
      <Table
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        scroll={{ x: "max-content" }}
        bordered
        dataSource={data}
        columns={newupdatedColumns}
        rowClassName="editable-row"
        style={{ width: "100%" }}
        onChange={handleTableChange}
        pagination={{
          onChange: () => { },
          position: ["bottomRight"],
        }}
        {...rest}
      />
    </Form>
  );
};

export default FormInlineTable;
